module.exports = __webpack_public_path__ + "static/img/ly.940fcee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ly.png
// module id = wJyD
// module chunks = 0